import { render, staticRenderFns } from "./WearehouseManagement.vue?vue&type=template&id=2c06cfa6&scoped=true&"
import script from "./WearehouseManagement.vue?vue&type=script&lang=js&"
export * from "./WearehouseManagement.vue?vue&type=script&lang=js&"
import style0 from "./WearehouseManagement.vue?vue&type=style&index=0&id=2c06cfa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c06cfa6",
  null
  
)

export default component.exports